export const GinVersion = '2.38.0';
export const GinBuild = '0000000003';
